import React, { Component } from 'react'
import Icon from "../common/icon/icon.component.jsx";
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";
import GlobalHelper from "../common/GlobalHelper.jsx";
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import ActionButton from "../common/button/actionbutton.component.jsx";
import QuestionConversationContent from "./questionconversationcontent.jsx";
import LoadingSpinner from "../common/spinner/loading.component.jsx";
import './questionconversation.scss'
import { TYPE_EMAIL } from '../state/conversation/ConversationThreadTypes';

const messages = defineMessages({
    "question_placeholder": {
        id: 'question.conversation.textarea_placeholder',
        defaultMessage: 'Ask your question here...',
    },
    "email_placeholder": {
        id: 'question.conversation.email_placeholder',
        defaultMessage: 'Your email',
    },
})

class QuestionConversationChat extends Component {

    constructor(props, context) {
        super(props, context)

        const variables = this.props.variables || null
        let documentInfoSection = null
        if (variables && variables.sections) {
            documentInfoSection = variables.sections.find(s => s.attributes.contentType === 'document-info')
        }

        this.state = {
            variables: this.props.variables || null,
            chatButtonLabel: (documentInfoSection && documentInfoSection.attributes) ?
                documentInfoSection.attributes.content.chatFloatingButtonLabel : '',
            chatVisible: this.props.chatVisible || undefined,
            project: this.props.variables && this.props.variables.project ? this.props.variables.project : null,
            selectedThread: this.props.selectedThread || 0,
            questionText: '',
            questionSubmitted: false,
            newEmail: '',
            submitLoading: false,
            loadingConversation: false,
            newNumberOfMessages: 0,
            newNumberOfMessagesText: '',
        }
        this.changeChatVisibility = this.changeChatVisibility.bind(this)
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let previousStateConversationThreads = []
        if (this.state.project.attributes) {
            previousStateConversationThreads = [...this.state.project.attributes.conversationThreads]
        } else {
            previousStateConversationThreads = [...this.state.project.conversationThreads]
        }
        this.setState({
            variables: nextProps.variables || null,
            project: nextProps.project || (nextProps.variables && nextProps.variables.project ? nextProps.variables.project : null),
            selectedThread: nextProps.selectedThread || 0,
        }, () => {
            if (previousStateConversationThreads.length > 0 && this.state.selectedThread != -1 && this.getNumberOfConversationMessages() >
                previousStateConversationThreads[this.state.selectedThread].messages.length) {
                const newNumberOfMessages = this.getNumberOfConversationMessages() - previousStateConversationThreads[this.state.selectedThread].messages.length
                this.setState({
                    newNumberOfMessages: this.state.newNumberOfMessages + newNumberOfMessages,
                    newNumberOfMessagesText: < FormattedMessage
                        id="question.conversation.new_message_notification"
                        defaultMessage="new message(s)"
                    />,
                })
            }
        })
    }

    reloadConversation() {
        AppContext.getApiClient().get(`/proposals/${this.state.variables.hash}`).then(r => {
            this.setState({
                variables: r.attributes.variables,
                project: r.attributes.variables.project,
                loadingConversation: false,
                selectedThread: GlobalHelper.getConversationThreadIndex(r.attributes.variables.project.conversationThreads, TYPE_EMAIL)
            })
        })
    }

    changeChatVisibility(event) {
        this.setState({
            chatVisible: !isNaN(this.state.chatVisible) ? !this.state.chatVisible : true,
            questionSubmitted: false,
        }, () => {
            if (this.state.chatVisible) {
                this.setState({
                    loadingConversation: true,
                })
                this.reloadConversation()
            } else {
                this.setState({
                    newNumberOfMessages: 0,
                    newNumberOfMessagesText: '',
                })
            }
        })
    }

    getNumberOfConversationMessages() {
        const conversationThreads = this.state.project ?
            (this.state.project.attributes ? this.state.project.attributes.conversationThreads : this.state.project.conversationThreads) : []
        const numberOfMessages = (conversationThreads.length > 0) && conversationThreads[this.state.selectedThread] ?
            conversationThreads[this.state.selectedThread].messages.length : 0
        return numberOfMessages
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();

        this.setState({
            submitLoading: true,
        })

        let conversationThreadId = ""
        if (this.state.selectedThread != -1) {
            conversationThreadId = this.state.selectedThread
        }

        let data = {
            sender: "customer",
            content: this.state.questionText,
            sellerId: this.state.variables.seller.id,
            customerId: this.state.variables.customer.contactId,
            accountId: this.state.variables.quote.accountId,
            customerEmail: this.state.newEmail,
            conversationThreadId: conversationThreadId,
        }

        if (this.state.variables.document.type == "quote") {
            data.quoteReferenceId = this.state.variables.quote.id
        } else if (this.state.variables.document.type == "invoice") {
            data.invoiceReferenceId = this.state.variables.quote.id
        } else if (this.state.variables.document.type == "order") {
            data.orderReferenceId = this.state.variables.quote.id
        }

        AppContext.getApiClient().post(`/proposals/${this.state.variables.hash}/messages`, data).then(res => {
            this.setState({
                submitLoading: false,
            })
            if (!res.error) {
                this.reloadConversation()

                if (this.state.newEmail) {
                    let variables = Object.assign({}, this.state.variables)
                    variables.customer.email = this.state.newEmail
                    this.setState({
                        variables,
                    })
                }

                this.setState({
                    questionSubmitted: true,
                    questionText: '',
                    newEmail: '',
                })
            }
        })
    }

    render() {
        if (this.state.variables && this.state.variables.quote.billingType === 'return') {
            return ''
        }

        return <div>
            {!this.state.chatVisible &&
                <div className={"fixed-question-conversation-chat-btn d-flex justify-content-center align-items-center px-3 py-2 text-white"} onClick={this.changeChatVisibility}
                    style={{
                        outlineColor: this.state.variables.global.buttonColor,
                        backgroundColor: this.state.variables.global.buttonColor,
                        borderColor: this.state.variables.global.buttonColor,
                        borderRadius: '20px',
                    }}>
                    <Icon value={!this.state.newNumberOfMessagesText ? 'comment' : 'bell'} size={'25px'} className="d-flex align-items-center"
                        iconText={!this.state.newNumberOfMessagesText ? this.getNumberOfConversationMessages() : this.state.newNumberOfMessages} />
                    {(GlobalHelper.getResponsiveBreakpoint() !== "xs" || this.state.newNumberOfMessagesText) &&
                        <span className={'ml-2'}>
                            {this.state.newNumberOfMessagesText ?
                                this.state.newNumberOfMessagesText
                                :
                                (
                                    this.state.chatButtonLabel ?
                                        this.state.chatButtonLabel
                                        :
                                        <FormattedMessage
                                            id="question.conversation.ask_a_question"
                                            defaultMessage="Ask a question"
                                        />
                                )

                            }
                        </span>
                    }
                </div>
            }

            <div className={'card question-conversation-chat ' + (!isNaN(this.state.chatVisible) ?
                (this.state.chatVisible ? 'show-question-conversation' : 'hide-question-conversation') : '')}>
                <div className="card-header flex-grow-0" style={{ backgroundColor: this.state.variables.global.backgroundColor }}>
                    <h5 className="card-title d-flex justify-content-between m-2">
                        <FormattedMessage
                            id="question.conversation.header"
                            defaultMessage="Questions and answers"
                        />
                        <span onClick={this.changeChatVisibility} style={{ cursor: 'pointer' }}>
                            <Icon value={'times'} className={'text-black'} size={'25px'} />
                        </span>
                    </h5>
                </div>
                <div id="questionConversationContentContainer" className="card-body rounded border-bottom mt-2 mb-1 pt-1 px-0 flew-grow-1 h-25" style={{ overflow: 'scroll' }}>
                    {!this.state.loadingConversation ?
                        <QuestionConversationContent project={this.state.project} selectedThread={this.state.selectedThread} isCustomer={true} /> :
                        <div className="d-flex justify-content-center align-items-center h-100">
                            <LoadingSpinner />
                        </div>
                    }
                </div>
                <div className="card-body pt-3 d-flex align-items-end flex-grow-0 px-4" >
                    <div className="w-100">
                        <form onSubmit={this.handleSubmit}>
                            {!this.state.questionSubmitted ?
                                <textarea
                                    name="questionText"
                                    value={this.state.questionText}
                                    rows="5"
                                    onChange={this.handleChange}
                                    id="questionText"
                                    className="form-control"
                                    placeholder={this.props.intl.formatMessage(messages["question_placeholder"])}
                                    style={{ height: '70%', resize: 'none' }}
                                    disabled={this.state.submitLoading}
                                /> : <div>
                                    <div className="text-justify alert alert-success">
                                        {(this.state.variables.customer.email || this.state.newEmail) &&
                                            <FormattedMessage
                                                id="question.conversation.question_submitted_with_email"
                                                defaultMessage="Your question has been submitted to the seller. You will receive an email notification at {customerEmail} once the seller replies."
                                                values={{
                                                    customerEmail: <b>{this.state.variables.customer.email || this.state.newEmail}</b>,
                                                }}
                                            />
                                        }
                                        {(!this.state.variables.customer.email && !this.state.newEmail) &&
                                            <FormattedMessage
                                                id="question.conversation.question_submitted_no_email"
                                                defaultMessage="Your question has been submitted to the seller. Come back later to this proposal to see if the seller has replied. You can enter your email and send another message to receive email notifications when the seller replies."
                                                values={{
                                                    customerEmail: <b>{this.state.variables.customer.email || this.state.newEmail}</b>,
                                                }}
                                            />
                                        }
                                    </div>
                                </div>
                            }

                            {!this.state.questionSubmitted && this.state.variables && this.state.variables.customer &&
                                !GlobalHelper.validateEmail(this.state.variables.customer.email) &&
                                <div className="mt-3 mb-4">
                                    <div className="text-secondary mb-2">
                                        <small>
                                            <FormattedMessage
                                                id="question.conversation.enter_email"
                                                defaultMessage="Enter your email to receive an email notification once the seller replies"
                                            />
                                        </small>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="newEmail"
                                        name="newEmail"
                                        value={this.state.newEmail}
                                        placeholder={this.props.intl.formatMessage(messages["email_placeholder"])}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            }

                            <div className="d-flex justify-content-between mt-3">
                                <button className="btn btn-secondary px-3 py-2" style={{
                                    fontSize: '1rem',
                                    fontWeight: 'bold',
                                    height: '12%',
                                }} onClick={this.changeChatVisibility} type="button"
                                >
                                    <FormattedMessage
                                        id="question.conversation.close"
                                        defaultMessage="Close"
                                    />
                                </button>
                                {!this.state.questionSubmitted &&
                                    <ActionButton
                                        type="button"
                                        className="btn btn-primary px-3 py-2 approve-btn"
                                        style={{
                                            outlineColor: this.state.variables.global.buttonColor,
                                            backgroundColor: this.state.variables.global.buttonColor,
                                            borderColor: this.state.variables.global.buttonColor,
                                            fontSize: '1rem',
                                            fontWeight: 'bold',
                                        }}
                                        disabled={!this.state.questionText}
                                        isLoading={this.state.submitLoading}
                                        onClick={this.handleSubmit}
                                    >
                                        <FormattedMessage
                                            id="question.conversation.send_message"
                                            defaultMessage="Send your message"
                                        />
                                    </ActionButton>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div >
    }


}

export default injectIntl(QuestionConversationChat)





// WEBPACK FOOTER //
// ./src/question-conversation/questionconversationchat.jsx